import { connect } from 'react-redux';
import AddSharedThreatPolicy from '../../components/shared_policies/AddSharedThreatPolicy';

import { updateSharedOptions } from '../../actions/shared_policies';

const mapStateToProps = (state, ownProps) => {
  return {
    display: false,
    fields: {
      ...state.shared_policies.fields,
      ...state.shared_policies.changes,
    },
  };
};

const mapDispatchToProps = dispatch => ({
  updateSetting: (name, value) => {
    dispatch(
      updateSharedOptions({
        [name]: value,
      })
    );
  },
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(AddSharedThreatPolicy);
